import { render, staticRenderFns } from "./EscolherAcesso.vue?vue&type=template&id=3996568d&scoped=true"
import script from "./EscolherAcesso.vue?vue&type=script&lang=js"
export * from "./EscolherAcesso.vue?vue&type=script&lang=js"
import style0 from "./EscolherAcesso.vue?vue&type=style&index=0&id=3996568d&prod&lang=scss&scoped=true"
import style1 from "./EscolherAcesso.vue?vue&type=style&index=1&id=3996568d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996568d",
  null
  
)

export default component.exports